import api from '@/api/api.js'

export default {
    saveConsultationProforma(data) {
        const promise = api.comptabilite().post('/facture-proforma', data)
        return promise.then((response) => response.data)
    },

    savePrestationProforma(data) {
        const promise = api.comptabilite().post('/facture-proforma/prestation/store', data)
        return promise.then((response) => response.data)
    },

    saveAutrePrestationProforma(data) {
        const promise = api.comptabilite().post('/facture-proforma/autre-prestation/store', data)
        return promise.then((response) => response.data)
    },

    getListePrestationProforma(data) {
        const promise = api.comptabilite().get('/facture-proforma/'+data.fproforma_id+'/liste-prestation/'+data.type_prestation)
        return promise.then((response) => response.data)
    },

    getListeChirurgieProforma(data) {
        const promise = api.comptabilite().get('/facture-proforma/'+data.fproforma_id+'/liste-chirurgie/'+data.type_prestation)
        return promise.then((response) => response.data)
    },

    removePrestationFromProforma(data) {
        const promise = api.comptabilite().post('/facture-proforma/delete/prestation', data)
        return promise.then((response) => response.data)
    },

    getFactureProforma(data) {
        const promise = api.comptabilite().post('/facture-proforma/liste', data)
        return promise.then((response) => response.data)
    },

    getSingleFactureProforma(fproforma_id) {
        const promise = api.comptabilite().get('/facture-proforma/'+fproforma_id)
        return promise.then((response) => response.data)
    },

    getTypePrestationFactureProforma(fproforma_id) {
        const promise = api.comptabilite().get('/facture-proforma/'+fproforma_id+'/type_prestations')
        return promise.then((response) => response.data)
    },

    deleteFactureProforma(data) {
        const promise = api.comptabilite().post('/facture-proforma/delete', data)
        return promise.then((response) => response.data)
    },

    saveProformaCommentaire(data) {
        const promise = api.comptabilite().post('/facture-proforma/add-comment', data)
        return promise.then((response) => response.data)
    },

    getInfoProforma(proforma_id) {
        const promise = api.comptabilite().get('/facture-proforma/'+proforma_id+'/info-fproforma')
        return promise.then((response) => response.data)
    },
}